<template>
  <b-modal
    id="modal-subscription"
    size="lg"
    :title="editUuid !== null ? 'Detail Berlangganan' : 'Tambah Berlangganan'"
  >
    <div>
      <div>
        <label for="v-nama"
          >Tipe Berlangganan <span class="text-danger">*</span></label
        >
        <b-form-group>
          <b-form-select
            class="custom__input"
            v-model="formPayload.type"
            :options="options"
          />
        </b-form-group>
      </div>
      <div>
        <label for="v-nama"
          >Nama Berlangganan <span class="text-danger">*</span></label
        >
        <b-form-group>
          <b-form-input
            id="v-nama"
            v-model="formPayload.renewal_name"
            type="text"
            placeholder="Nama Berlangganan"
            class="custom__input"
          />
        </b-form-group>
      </div>
      <div>
        <label for="v-description">Deskripsi Berlangganan</label>
        <b-form-group>
          <b-form-input
            id="v-description"
            v-model="formPayload.renewal_description"
            type="text"
            placeholder="Deskripsi"
            class="custom__input"
          />
        </b-form-group>
      </div>
      <div>
        <label for="v-months"
          >Masa Berlangganan (Bulan) <span class="text-danger">*</span></label
        >
        <b-form-group>
          <money
            id="v-months"
            v-model="formPayload.renewal_duration_months"
            v-bind="money"
            placeholder="Masa Berlangganan"
            class="form-control custom__input"
          />
        </b-form-group>
      </div>
      <div
        v-if="
          formPayload.type == 'user_subscription' ||
            formPayload.type == 'extend_user_subscription'
        "
      >
        <label for="v-months"
          >User Count <span class="text-danger">*</span></label
        >
        <b-form-group>
          <money
            id="v-branch-count"
            v-model="formPayload.user_count"
            v-bind="money"
            placeholder="Jumlah Pengguna"
            class="form-control custom__input"
          />
        </b-form-group>
      </div>
      <div
        v-if="
          formPayload.type == 'branch_subscription' ||
            formPayload.type == 'extend_branch_subscription'
        "
      >
        <label for="v-months"
          >Branch Count <span class="text-danger">*</span></label
        >
        <b-form-group>
          <money
            id="v-branch-count"
            v-model="formPayload.branch_count"
            v-bind="money"
            placeholder="Jumlah Cabang"
            class="form-control custom__input"
          />
        </b-form-group>
      </div>
      <div>
        <b-form-group label-for="v-harga">
          <label for="">Harga <span class="text-danger">*</span></label>
          <b-input-group class="input-group-merge">
            <template #prepend>
              <b-input-group-text
                :style="
                  isFocusPrice ? 'background: white' : 'background: #eff1f5;'
                "
                >Rp</b-input-group-text
              >
            </template>
            <money
              id="v-harga"
              v-model="formPayload.price"
              v-bind="money"
              placeholder="Harga"
              class="pl-25 form-control custom__input border-rad-top-left-0 border-rad-bottom-left-0 border-rad-top-right-8 border-rad-bottom-right-8"
              @focus="isFocusPrice = true"
            />
          </b-input-group>
        </b-form-group>
      </div>
      <b-form-group label-for="v-harga-jual">
        <label for="">Harga Jual <span class="text-danger">*</span></label>
        <b-input-group class="input-group-merge">
          <template #prepend>
            <b-input-group-text
              :style="
                isFocusBuyingPrice
                  ? 'background: white'
                  : 'background: #eff1f5;'
              "
              >Rp</b-input-group-text
            >
          </template>
          <money
            id="v-harga-jual"
            v-model="formPayload.sell_price"
            v-bind="money"
            placeholder="Harga"
            class="pl-25 form-control custom__input border-rad-top-left-0 border-rad-bottom-left-0 border-rad-top-right-8 border-rad-bottom-right-8"
            @focus="isFocusBuyingPrice = true"
          />
        </b-input-group>
      </b-form-group>
      <div>
        <label for="v-discount"
          >Diskon (%) <span class="text-danger">*</span></label
        >
        <b-form-group>
          <b-form-input
            id="v-discount"
            v-model="formPayload.discount_percent"
            type="text"
            placeholder="Diskon"
            class="custom__input"
          />
        </b-form-group>
      </div>
      <div>
        <label for="v-is-active"
          >Is Active <span class="text-danger">*</span></label
        >
        <b-form-group>
          <b-form-checkbox
            v-model="formPayload.is_active"
            class="custom-control-primary"
          >
            {{ formPayload.is_active ? 'Active' : 'Non Active' }}
          </b-form-checkbox>
        </b-form-group>
      </div>
    </div>
    <template #modal-footer="{}">
      <b-button
        variant="primary"
        @click="updateItem()"
        :disabled="disabledFormOnNull"
      >
        Simpan
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';
import {
  BModal,
  BContainer,
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BFormDatepicker,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupText,
  BFormCheckbox,
} from 'bootstrap-vue';
import vSelect from 'vue-select';

import BaseInput from '@/components/BaseInput.vue';

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BButton,
    BContainer,
    BaseInput,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormSelect,
    BFormSelectOption,
    BFormDatepicker,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupText,
    BFormCheckbox,
  },
  props: {
    formData: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: '',
    },
    getData: {
      type: Function,
    },
    result: {
      type: Object,
    },
    // getDetail: {
    //   type: Function,
    // },
    detailResult: {
      type: Object,
    },
    editItem: {
      type: Function,
    },
    updateItem: {
      type: Function,
    },
    editId: {
      type: '',
    },
    cleanUpForm: {
      type: Function,
    },
  },
  computed: {
    disabledFormOnNull() {
      const { type, renewal_name } = this.formPayload;

      const disabledPayload = {
        type,
        renewal_name,
      };
      return Object.values(disabledPayload).some((val) => val === null);
    },
  },
  watch: {
    editId(value) {
      this.editUuid = value;
    },
    formData(value) {
      this.formPayload = value;
    },
    formPayload: {
      handler(value) {
        this.$emit('getPayload', value);
      },
      deep: true,
    },
  },
  data() {
    return {
      editUuid: null,
      money: {
        decimal: '',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false,
      },
      formPayload: {
        type: null,
        renewal_name: null,
        renewal_description: '',
        renewal_duration_months: null,
        price: 0,
        sell_price: 0,
        discount_percent: 0,
        user_count: 0,
        branch_count: 0,
        is_active: false,
      },
      searchQuery: '',
      countryList: [],
      optionsToko: [],
      isFocusPrice: false,
      isFocusBuyingPrice: false,
      options: [
        { value: null, text: 'Please select an option' },
        { value: 'main_subscription', text: 'Main Subcription' },
        { value: 'user_subscription', text: 'User Subscription' },
        { value: 'branch_subscription', text: 'Branch Subscription' },
        { value: 'extend_user_subscription', text: 'Extend User Subscription' },
        {
          value: 'extend_branch_subscription',
          text: 'Extend Branch Subscription',
        },
      ],
    };
  },
  mounted() {},
  methods: {
    directPage() {
      //   this.cleanUpForm()
      this.$bvModal.hide('modal-subscription');
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss">
@import '@/assets/scss/variables/_variables.scss';

label {
  font-size: 14px;
  font-weight: 600;
  color: #2b324f;
}

.custom__input {
  height: 52px;
  background: #eff1f5;
  border: 1px solid #e4e5ec;
  border-radius: 8px;
  color: #2b324f;
  font-weight: 600;
  font-size: 14px;
}
.input-group-text {
  background: #eff1f5;
}
</style>
